import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-popup-menu-vertical-scroll', {
    overflowY: 'auto',
    overflowX: 'hidden',
    maxHeight: '313.2px',
});

cssRule('.tb-popup-menu-vertical-scroll', {
    overflowY: 'auto',
    overflowX: 'hidden',
    maxHeight: '313.2px',
});

cssRule('.tb-popup-menu-button', {
    position: 'relative',
    height: '21px',
    lineHeight: '21px',
    border: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.default, '#b2b2b2'),
    paddingLeft: '6px',
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, '#fff'),
    cursor: 'pointer',
});

cssRule('.tb-popup-menu-button >.tb-text', {
    color: applyColor(DesignTokens.color.font.default.default, '#2e2e2e'),
    paddingRight: '25px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});

cssRule('.tb-popup-menu-button >.tb-line', {
    position: 'absolute',
    top: 0,
    right: '18px',
    bottom: 0,
    left: 'auto',
    width: '1px',
    backgroundColor: applyColor(DesignTokens.color.elevation.border.default.default, '#b2b2b2'),
});

cssRule('.tb-popup-menu-button >.tb-arrow', {
    position: 'absolute',
    top: '1px',
    right: 0,
    bottom: '1px',
    left: 'auto',
    width: '19px',
    height: '19px',
    background: 'url(img/dropdown_arrow_normal.svg?1_0_9606_yabs0uv7t1h) no-repeat',
});

cssRule('.tb-popup-menu-button:hover', {
    border: '1px solid ' + applyColor(DesignTokens.color.component.border.neutral.default.hover, '#666'),
});

cssRule('.tb-popup-menu-button:hover >.tb-text', {
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
});

cssRule('.tb-popup-menu-button:hover >.tb-line', {
    backgroundColor: applyColor(DesignTokens.color.elevation.border.default.subtle, '#666'),
});

cssRule('.tb-popup-menu-button:hover >.tb-arrow', {
    background: 'url(img/dropdown_arrow_pressed.svg?1_0_9606_yabs0uv7t1h) no-repeat',
});

cssRule('.tb-popup-menu-button.tb-selected, .tb-popup-menu-button.tb-selected:hover', {
    border: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.default, '#b2b2b2'),
});

cssRule('.tb-popup-menu-button.tb-selected >.tb-text, .tb-popup-menu-button.tb-selected:hover >.tb-text', {
    color:applyColor(DesignTokens.color.font.default.default, '#2e2e2e'),
});

cssRule('.tb-popup-menu-button.tb-selected >.tb-line, .tb-popup-menu-button.tb-selected:hover >.tb-line', {
    backgroundColor: applyColor(DesignTokens.color.elevation.border.default.default, '#b2b2b2'),
});

cssRule('.tb-popup-menu-button.tb-selected >.tb-arrow, .tb-popup-menu-button.tb-selected:hover >.tb-arrow', {
    background: 'url(img/dropdown_arrow_normal.svg?1_0_9606_yabs0uv7t1h) no-repeat',
});

cssRule('.tb-popup-menu-button.tb-disabled, .tb-popup-menu-button.tb-disabled:hover', {
    cursor: 'default',
    border: '1px solid ' + applyColor(DesignTokens.color.component.border.neutral.default.default, '#e1e1e1'),
});

cssRule('.tb-popup-menu-button.tb-disabled >.tb-text, .tb-popup-menu-button.tb-disabled:hover >.tb-text', {
    color: applyColor(DesignTokens.color.font.default.disabled, '#c9c9c9'),
});

cssRule('.tb-popup-menu-button.tb-disabled >.tb-line, .tb-popup-menu-button.tb-disabled:hover >.tb-line', {
    backgroundColor: applyColor(DesignTokens.color.component.background.neutral.default.non_btn.hover, '#e1e1e1'),
});

cssRule('.tb-popup-menu-button.tb-disabled >.tb-arrow, .tb-popup-menu-button.tb-disabled:hover >.tb-arrow', {
    background: 'url(img/dropdown_arrow_disabled.svg?1_0_9606_yabs0uv7t1h) no-repeat',
});

cssRule('.tb-popup-menu-button', {
    position: 'relative',
    height: '21px',
    lineHeight: '21px',
    border: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.default, '#b2b2b2'),
    paddingLeft: '6px',
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, '#fff'),
    cursor: 'pointer',
});

cssRule('.tb-popup-menu-button >.tb-text', {
    color:applyColor(DesignTokens.color.font.default.default, '#2e2e2e'),
    paddingRight: '25px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});

cssRule('.tb-popup-menu-button >.tb-line', {
    position: 'absolute',
    top: 0,
    right: '18px',
    bottom: 0,
    left: 'auto',
    width: '1px',
    backgroundColor: applyColor(DesignTokens.color.elevation.border.default.default, '#b2b2b2'),
});

cssRule('.tb-popup-menu-button >.tb-arrow', {
    position: 'absolute',
    top: '1px',
    right: 0,
    bottom: '1px',
    left: 'auto',
    width: '19px',
    height: '19px',
    background: 'url(img/dropdown_arrow_normal.svg?1_0_9606_yabs0uv7t1h) no-repeat',
});

cssRule('.tb-popup-menu-button:hover', {
    border: '1px solid ' + applyColor(DesignTokens.color.component.border.neutral.default.hover, '#666'),
});

cssRule('.tb-popup-menu-button:hover >.tb-text', {
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
});

cssRule('.tb-popup-menu-button:hover >.tb-line', {
    backgroundColor: applyColor(DesignTokens.color.elevation.border.default.subtle, '#666'),
});

cssRule('.tb-popup-menu-button:hover >.tb-arrow', {
    background: 'url(img/dropdown_arrow_pressed.svg?1_0_9606_yabs0uv7t1h) no-repeat',
});

cssRule('.tb-popup-menu-button.tb-selected, .tb-popup-menu-button.tb-selected:hover', {
    border: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.default, '#b2b2b2'),
});

cssRule('.tb-popup-menu-button.tb-selected >.tb-text, .tb-popup-menu-button.tb-selected:hover >.tb-text', {
    color:applyColor(DesignTokens.color.font.default.default, '#2e2e2e'),
});

cssRule('.tb-popup-menu-button.tb-selected >.tb-line, .tb-popup-menu-button.tb-selected:hover >.tb-line', {
    backgroundColor: applyColor(DesignTokens.color.elevation.border.default.default, '#b2b2b2'),
});

cssRule('.tb-popup-menu-button.tb-selected >.tb-arrow, .tb-popup-menu-button.tb-selected:hover >.tb-arrow', {
    background: 'url(img/dropdown_arrow_normal.svg?1_0_9606_yabs0uv7t1h) no-repeat',
});

cssRule('.tb-popup-menu-button.tb-disabled, .tb-popup-menu-button.tb-disabled:hover', {
    cursor: 'default',
    border: '1px solid ' + applyColor(DesignTokens.color.component.border.neutral.default.default, '#e1e1e1'),
});

cssRule('.tb-popup-menu-button.tb-disabled >.tb-text, .tb-popup-menu-button.tb-disabled:hover >.tb-text', {
    color: applyColor(DesignTokens.color.font.default.disabled, '#c9c9c9'),
});

cssRule('.tb-popup-menu-button.tb-disabled >.tb-line, .tb-popup-menu-button.tb-disabled:hover >.tb-line', {
    backgroundColor: applyColor(DesignTokens.color.component.background.neutral.default.non_btn.hover, '#e1e1e1'),
});

cssRule('.tb-popup-menu-button.tb-disabled >.tb-arrow, .tb-popup-menu-button.tb-disabled:hover >.tb-arrow', {
    background: 'url(img/dropdown_arrow_disabled.svg?1_0_9606_yabs0uv7t1h) no-repeat',
});

cssRule('.tb-popup-menu-content', {
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, '#fff'),
    border: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.default, '#b2b2b2'),
    minWidth: '144px',
    /* error: '-moz-box-shadow': '0 7px 15px rgba(0,0,0,0.2)', */
    '-webkit-box-shadow': '0 7px 15px '+ applyColor(DesignTokens.color.feedback.default.neutral_dark, 'rgba(0,0,0,0.2)'),
    boxShadow: '0 7px 15px '+ applyColor(DesignTokens.color.feedback.default.neutral_dark, 'rgba(0,0,0,0.2)'),
});

cssRule('.tb-popup-menu-content', {
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, '#fff'),
    border: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.default, '#b2b2b2'),
    minWidth: '144px',
    /* error: '-moz-box-shadow': '0 7px 15px rgba(0,0,0,0.2)', */
    '-webkit-box-shadow': '0 7px 15px '+ applyColor(DesignTokens.color.feedback.default.neutral_dark, 'rgba(0,0,0,0.2)'),
    boxShadow: '0 7px 15px '+ applyColor(DesignTokens.color.feedback.default.neutral_dark, 'rgba(0,0,0,0.2)'),
});

cssRule('.tb-popup-menu-content-expand', {
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, '#fff'),
    border: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.default, '#b2b2b2'),
    minWidth: 'max-content',
    /* error: '-moz-box-shadow': '0 7px 15px rgba(0,0,0,0.2)', */
    '-webkit-box-shadow': '0 7px 15px '+ applyColor(DesignTokens.color.feedback.default.neutral_dark, 'rgba(0,0,0,0.2)'),
    boxShadow: '0 7px 15px '+ applyColor(DesignTokens.color.feedback.default.neutral_dark, 'rgba(0,0,0,0.2)'),
});

cssRule('.tb-popup-menu-content-expand', {
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, '#fff'),
    border: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.default, '#b2b2b2'),
    minWidth: 'max-content',
    /* error: '-moz-box-shadow': '0 7px 15px rgba(0,0,0,0.2)', */
    '-webkit-box-shadow': '0 7px 15px '+ applyColor(DesignTokens.color.feedback.default.neutral_dark, 'rgba(0,0,0,0.2)'),
    boxShadow: '0 7px 15px '+ applyColor(DesignTokens.color.feedback.default.neutral_dark, 'rgba(0,0,0,0.2)'),
});

cssRule('.tb-select-option, .tb-popup-menu-item', {
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    height: '27px',
    lineHeight: '27px',
    paddingLeft: '6px',
    paddingRight: '6px',
    backgroundColor: 'inherit',
    color:applyColor(DesignTokens.color.font.default.default, '#2e2e2e'),
    textDecoration: 'none',
    cursor: 'pointer',
    position: 'relative',
});

cssRule('.tb-select-option:hover, .tb-popup-menu-item:hover', {
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.subtle, '#F5F5F5'),
    color:applyColor(DesignTokens.color.font.default.default, '#2e2e2e'),
    textDecoration: 'none',
});

cssRule('.tb-select-option:active, .tb-popup-menu-item:active', {
    backgroundColor: applyColor(DesignTokens.color.component.background.neutral.default.active, '#e6e6e6'),
    color:applyColor(DesignTokens.color.font.default.default, '#2e2e2e'),
});

cssRule('.tb-select-option.tb-disabled, .tb-popup-menu-item.tb-disabled', {
    color: applyColor(DesignTokens.color.font.default.disabled, '#e1e1e1'),
    cursor: 'default',
});

cssRule('.tb-select-option.tb-disabled:hover, .tb-popup-menu-item.tb-disabled:hover', {
    color: applyColor(DesignTokens.color.font.default.disabled, '#e1e1e1'),
    backgroundColor: 'inherit',
});

cssRule('.tb-select-option, .tb-popup-menu-item', {
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    height: '27px',
    lineHeight: '27px',
    paddingLeft: '6px',
    paddingRight: '6px',
    backgroundColor: 'inherit',
    color:applyColor(DesignTokens.color.font.default.default, '#2e2e2e'),
    textDecoration: 'none',
    cursor: 'pointer',
    position: 'relative',
});

cssRule('.tb-select-option:hover, .tb-popup-menu-item:hover', {
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.subtle, '#F5F5F5'),
    color:applyColor(DesignTokens.color.font.default.default, '#2e2e2e'),
    textDecoration: 'none',
});

cssRule('.tb-select-option:active, .tb-popup-menu-item:active', {
    backgroundColor: applyColor(DesignTokens.color.component.background.neutral.default.active, '#e6e6e6'),
    color:applyColor(DesignTokens.color.font.default.default, '#2e2e2e'),
});

cssRule('.tb-select-option.tb-disabled, .tb-popup-menu-item.tb-disabled', {
    color: applyColor(DesignTokens.color.font.default.disabled, '#e1e1e1'),
    cursor: 'default',
});

cssRule('.tb-select-option.tb-disabled:hover, .tb-popup-menu-item.tb-disabled:hover', {
    color: applyColor(DesignTokens.color.font.default.disabled, '#e1e1e1'),
    backgroundColor: 'inherit',
});

cssRule('.tb-select-option-selected', {
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.subtle, '#F5F5F5'),
    color:applyColor(DesignTokens.color.font.default.default, '#2e2e2e'),
    textDecoration: 'none',
});

cssRule('.tb-select-option-selected', {
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.subtle, '#F5F5F5'),
    color:applyColor(DesignTokens.color.font.default.default, '#2e2e2e'),
    textDecoration: 'none',
});

cssRule('.tb-select-option-count', {
    position: 'absolute',
    right: '6px',
    textAlign: 'right',
});

cssRule('.tb-select-option-count', {
    position: 'absolute',
    right: '6px',
    textAlign: 'right',
});

cssRule('tr.tb-popup-menu-item', {
    display: 'table-row',
});

cssRule('tr.tb-popup-menu-item', {
    display: 'table-row',
});

